var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1358,
    height: 1358,
    viewBox: "0 0 1358 1358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679.604 987.062C964.019 987.062 1193.35 1001.15 1193.35 1019.07C1193.35 1036.99 962.738 1051.07 679.604 1051.07C395.189 1051.07 165.863 1036.99 165.863 1019.07C164.582 1001.15 395.189 987.062 679.604 987.062Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.962 521.08C833.348 586.372 577.118 605.575 343.949 577.41L137.684 442.985C117.185 394.336 97.9681 343.127 89 306C395.195 503.156 773.134 558.206 981.962 521.08Z",
    fill: "#99CC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.931 578.691C318.308 544.125 277.311 482.674 255.532 440.426C220.941 444.266 168.414 445.547 137.666 444.267L343.931 578.691Z",
    fill: "#004033"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1268.93 307.289C1203.59 554.374 1035.76 815.542 794.905 1019.1H563.017C533.55 993.495 504.084 967.891 475.898 941.006C847.432 816.823 1157.47 541.572 1268.93 307.289Z",
    fill: "#0096DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M794.904 1019.09C751.345 992.201 715.473 964.036 679.6 930.75C647.572 965.316 605.294 996.042 564.297 1019.09H794.904Z",
    fill: "#003399"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1122.87 467.301C987.07 620.929 779.524 748.952 538.668 816.805L315.748 756.634C296.531 731.029 278.594 705.425 261.939 679.82C533.543 673.419 873.048 651.655 1122.87 467.301Z",
    fill: "#FFBA00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.676 816.831C500.242 783.545 477.181 764.342 440.028 727.215C401.593 740.017 359.315 748.979 317.037 756.66L538.676 816.831Z",
    fill: "#FF5400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.667956c7b85b700bcfcddb52887f250c.svg";
export { ForwardRef as ReactComponent };